type Headline2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const headline2: Headline2 = {
    'fontFamily': 'var(--plasma-typo-headline2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-headline2-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-headline2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-headline2-font-size, 1.5rem)',
    'letterSpacing': 'var(--plasma-typo-headline2-letter-spacing, -0.0220em)',
    'lineHeight': 'var(--plasma-typo-headline2-line-height, 1.75rem)'
};